import React from "react"

const IconLabel = ({
  label,
  icon,
  onClick,
  backgroundColor = "#ffc7a733",
  iconColor = "black",
  style = {},
  labelStyle = {},
  iconContainer = {},
  iconStyle = {},
}) => {
  return (
    <div
      className="d-flex flex-row align-items-center"
      onClick={onClick}
      style={style}
    >
      <div
        style={{
          backgroundColor: backgroundColor,
          borderRadius: 5,
          width: 38,
          height: 38,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          ...iconContainer,
        }}
      >
        <i
          className={icon}
          style={{ color: iconColor, ...iconStyle }}
          aria-hidden="true"
        ></i>
      </div>
      <p className="mb-0 ml-2 bold" style={labelStyle}>
        {label}
      </p>
    </div>
  )
}

export default IconLabel
